import { render, staticRenderFns } from "./PlannedLeaveSection.vue?vue&type=template&id=6e4a5a24&scoped=true"
import script from "./PlannedLeaveSection.vue?vue&type=script&lang=js"
export * from "./PlannedLeaveSection.vue?vue&type=script&lang=js"
import style0 from "./PlannedLeaveSection.vue?vue&type=style&index=0&id=6e4a5a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a5a24",
  null
  
)

export default component.exports